import { type Policy, type UpdatePolicyBody } from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const settingsEndpoints = {
  /** The platform policy switches — the Settings page's audit-policy toggles. */
  policies() {
    return authenticated<Policy[]>(`${API_PREFIX}/admin/settings/policies`);
  },

  updatePolicy(key: string, enabled: boolean) {
    const body: UpdatePolicyBody = { enabled };
    return authenticated<Policy>(`${API_PREFIX}/admin/settings/policies/${key}`, {
      method: 'PUT',
      body,
    });
  },
};
